<markdown [class]="getMarkdownStyles"><ng-content></ng-content></markdown>
